import { render, staticRenderFns } from "./VacancyCandidatesRejected.vue?vue&type=template&id=f0d98a98&scoped=true"
import script from "./VacancyCandidatesRejected.vue?vue&type=script&lang=js"
export * from "./VacancyCandidatesRejected.vue?vue&type=script&lang=js"
import style0 from "./VacancyCandidatesRejected.vue?vue&type=style&index=0&id=f0d98a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d98a98",
  null
  
)

export default component.exports